import VueFinalModal from 'vue-final-modal'
import { shallowReactive } from 'vue'

export default function InstallVueBsModal(NetteAjax) {
  return NetteAjax.ext('vue-modal', {
    /*
    before: function (settings) {
     
    },
    */
    success: function (payload, response, settings) {
      if (!this.$vfm) return

      if (payload.closeModal && this.modalStack.indexOf(payload.closeModal) !== -1) {
        this.$vfm.hide(payload.closeModal)
      }
      
      if (!payload.snippets) {
        return
      }

      let newOpenModal = false

      if (settings.nette?.ui?.dataset?.modalId) {
        newOpenModal = settings.nette.ui.dataset.modalId
      } else if (payload?.state?.snippetName && payload.state.snippetName.substr(0, 5) === 'modal') {
        newOpenModal = payload.state.snippetName
      }

      // only add modal to stack when modal is not already open
      if (newOpenModal && this.modalStack.indexOf(newOpenModal) !== -1) {
        newOpenModal = false
      }

      if (!newOpenModal) {
        return
      }

      this.afterModalClose[newOpenModal] = () => {
        if (typeof settings.afterModalClose === 'function') {
          settings.afterModalClose(NetteAjax.lastResponse)
        } else if (settings.nette && typeof settings.nette.ui.afterModalClose === 'function') {
          settings.nette.ui.afterModalClose(NetteAjax.lastResponse)
        }
        
        delete this.afterModalClose[newOpenModal]
        const modalIndex = this.modalStack.indexOf(newOpenModal)
        this.modalStack.splice(modalIndex, 1)
      }

      this.modalStack.push(newOpenModal)
      this.$vfm.show(newOpenModal)
    }
  }, {
    afterModalClose: {}, // modal snippetName => callback
    $vfm: null,
    install(Vue/*, context*/) {
      Vue.use(VueFinalModal())
      this.$vfm = Vue.config.globalProperties['$vfm']
      
      Vue.directive('after-modal-close', (el, binding) => {
        if (typeof binding.value === 'function') {
          el.afterModalClose = binding.value
        }
      })
    },
    modalStack: shallowReactive([]), // opened modal snippetName
  })
}
